module.exports = __webpack_public_path__ + "img/LogoBlue.ff9d26ae.svg";